/**
 * Bootstrap: apply financial-rates.json to FinancialConfig before calculators run.
 * Sets the full rates root (including agePensionSchedules) so Age Pension /
 * deeming getters resolve from scraped schedules, not only hardcoded fallbacks.
 */
import ratesJson from '../public/data/financial-rates.json';
import { hydrateFinancialConfigFromJson, setRatesJsonRoot } from './FinancialConfig.js';
import { resolveFinancialYearRates } from './resolveFinancialYearRates.js';

setRatesJsonRoot(ratesJson);
hydrateFinancialConfigFromJson(resolveFinancialYearRates(ratesJson, new Date()));
